import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import axios from "axios";
import API from "../API";
import './Rating.css';
import Main from "../layout/main";
import {Col, Container, Row} from "reactstrap";

const Rating = ({ provider_avatar, provider_name, provider_project_id }) => {
    // Get project_id from URL path
    const pathname = window.location.pathname;
    const project_id = pathname.split('/').pop();  // Gets the last segment of the URL
    console.log('Project ID from URL:', project_id);

    const history = useHistory();
    const [rating, setRating] = useState(0);
    const [review, setReview] = useState("");
    const [loading, setLoading] = useState(false);
    const [state, setState] = useState({
        files: [],
        ratingError: ""
    });

    // Add new state variables for provider details
    const [providerDetails, setProviderDetails] = useState({
        avatar: provider_avatar,
        name: provider_name
    });

    // Add useEffect to fetch provider details
    useEffect(() => {
        const fetchProviderDetails = async () => {
            try {
                const response = await axios.get(
                    `${API.baseURL}/user_profile.json`,
                    API.options
                );
                console.log(response,'responseresponse');

                setProviderDetails({
                    avatar: response.data.data.avatar || provider_avatar,
                    name: response.data.data.name || provider_name
                });
            } catch (error) {
                console.error('Error fetching provider details:', error);
            }
        };

        fetchProviderDetails();
    }, []);

    const multipleImagePickerHandler = async (event) => {
        try {
            const selectedFiles = Array.from(event.target.files);
            
            for (const file of selectedFiles) {
                const imageUrl = URL.createObjectURL(file);
                
                const fileObj = {
                    blob: file,
                    url: imageUrl,
                    type: "image",
                    where: "local",
                };

                setState(prevState => ({
                    ...prevState,
                    files: [...prevState.files, fileObj]
                }));
            }
        } catch (error) {
            console.error('Error selecting images:', error);
        }
    };

    const removeSelectedFile = (index) => {
        setState(prevState => ({
            ...prevState,
            files: prevState.files.filter((_, i) => i !== index)
        }));
    };

    const handleSubmit = async () => {
        setState(prev => ({
            ...prev,
            ratingError: ""
        }));

        if (rating === 0) {
            setState(prev => ({
                ...prev,
                ratingError: "Please rate the provider before proceeding"
            }));
            return;
        }

        setLoading(true);
        const formData = new FormData();
        formData.append('id', project_id);
        formData.append('rating', rating);
        formData.append('description', review);
        state.files.forEach((data) => {
            formData.append('documents[]', data.blob);
        });

        try {
            await axios.post(
                `${API.baseURL}/v2/customers/projects/${project_id}/mark_as_complete`,
                formData,
                API.options
            );
            history.push(`/dashboard`);
        } catch (error) {
            console.error('Error submitting review:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <Main>
                <section className="ebw-section__pages">
                    <Container>
                        <Row>
                            <Col md={{size: 6, offset: 3}}>
                                <div className="rating-container" >
                                    <div className="rating-section w-full">
                                        <h4 className="mb-5">Mark project as complete</h4>

                                        <div className="provider-info">
                                            <div className="provider-avatar">
                                                <img
                                                    src={providerDetails?.avatar || "/assets/images/New-files/default-card-img-a.png"}
                                                    alt={providerDetails?.name}
                                                />
                                            </div>
                                            <div className="provider-details ml-0">
                                                <h5>{providerDetails?.name}</h5>
                                                <div className="star-rating mt-2">
                                                    {[1, 2, 3, 4, 5].map((star) => (
                                                        <svg
                                                            key={star}
                                                            onClick={() => setRating(star)}
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="24"
                                                            height="24"
                                                            viewBox="0 0 24 24"
                                                            fill={rating >= star ? "#FFD700" : "none"}
                                                            stroke={rating >= star ? "#FFD700" : "#666"}
                                                            strokeWidth="2"
                                                            style={{cursor: 'pointer', marginRight:5}}
                                                        >
                                                            <path
                                                                d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                                                        </svg>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>

                                        {state.ratingError && <div className="ebw-error">{state.ratingError}</div>}

                                        <textarea
                                            value={review}
                                            onChange={(e) => setReview(e.target.value)}
                                            placeholder="Leave a review"
                                            className="review-textarea"
                                        />

                                        <div className="media-upload-section">
                                            <p>Upload pictures of the completed project</p>
                                            <label className="upload-button" htmlFor="image-upload">
                                                <img src="/assets/images/New-files/upload-icons.png" alt=""/>
                                                <span>Upload Media</span>
                                                <input
                                                    id="image-upload"
                                                    type="file"
                                                    multiple
                                                    accept="image/*"
                                                    onChange={multipleImagePickerHandler}
                                                    style={{display: 'none'}}
                                                />
                                            </label>
                                        </div>

                                        {state.files.length > 0 && (
                                            <div className="uploaded-files">
                                                <h4>Uploaded files</h4>
                                                <div className="files-grid">
                                                    {state.files.map((file, index) => (
                                                        <div key={index} className="file-item">
                                                            <button
                                                                className="remove-file"
                                                                onClick={() => removeSelectedFile(index)}
                                                            >
                                                                ×
                                                            </button>
                                                            <img src={file.url} alt="Uploaded"/>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}

                                        <div className="text-center mt-4">
                                            <button
                                                className="ec-button__primary save-button user-select-none"
                                                onClick={handleSubmit}
                                                disabled={loading}
                                            >
                                                {loading ? (
                                                    <div className="spinner-border spinner-border-sm text-white" role="status"></div>
                                                ) : (
                                                    'Submit Feedback'
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </Main>
        </div>
    );
};


Rating.defaultProps = {
    provider_avatar: "",
    provider_name: "",
    provider_project_id: ""
};

export default Rating; 